import { Calendar as bcCalendar, CalendarProps } from '@britishcouncil/react-admin';
import styled from '@emotion/styled';
import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

type CustomCalendarProps = CalendarProps & {
  isLoading?: boolean;
  customCell?: (day: Date) => React.ReactNode;
};

export const Calendar = ({ customCell, isLoading, ...props }: CustomCalendarProps) => {
  const defaultRenderDay = React.useCallback(
    (day: Date) => {
      return (
        <S.CellContainer>
          <S.CellDay>{day.getDate()}</S.CellDay>
          {customCell?.(day)}
        </S.CellContainer>
      );
    },
    [customCell]
  );

  return (
    <S.CallendarContainer data-testid="calendar">
      <Dimmer active={isLoading} inverted>
        {isLoading && <Loader active />}
      </Dimmer>
      <MemoizedCalendar {...props} firstDayOfWeek={1} renderDay={defaultRenderDay} />
    </S.CallendarContainer>
  );
};

const MemoizedCalendar = React.memo(bcCalendar);

const S = {
  CallendarContainer: styled.div`
    && {
      .DayPicker-Day {
        height: 7.25rem;
        padding: 0;
        background-color: white;
        background-clip: padding-box;

        &--selected:not(&--disabled):not(&--outside) {
          background-color: rgb(21, 109, 175);
          color: white;
        }
      }

      .DayPicker-Month {
        table-layout: fixed;
        width: 100%;
      }
    }
  `,
  CellContainer: styled.div`
    min-width: 7rem;
    height: 100%;
    cursor: pointer;
  `,
  CellDay: styled.div`
    font-size: 1.5rem;
    font-weight: 300;
    position: absolute;
    top: 8px;
    left: 8px;
  `,
};
